import React from 'react';

const DailymotionPlayer = ({ videoId }) => {
  if (!videoId) return null;

  return (
    <div style={{
      position: 'relative',
      paddingBottom: '56.25%', // Ratio 16:9
      height: 0,
      overflow: 'hidden',
      borderRadius: '12px',
      backgroundColor: '#000'
    }}>
      <iframe
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        src={`https://www.dailymotion.com/embed/video/${videoId}?autoplay=0&mute=1&api=postMessage`}
        frameBorder="0"
        allowFullScreen
        allow="autoplay; fullscreen; picture-in-picture"
        title="Dailymotion Video Player"
      ></iframe>
    </div>
  );
};

export default DailymotionPlayer;